<template>
  <div>
    <div class="h-toolbarBg">
      <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
    </div>
    <div class="h100-80 h-scroll">
      <ejs-grid :dataSource="devData" ref="grid">
        <e-columns>
          <e-column type="checkbox" width="50" textAlign="center"></e-column>
          <e-column field="id" :visible="false"></e-column>
          <e-column field="neId" :visible="false"></e-column>
          <e-column field="equipmentName" :headerText="$t('Topo.envirommentName')" width="120" textAlign="Center"></e-column>
          <e-column field="typeName" :headerText="$t('Topo.devType')" width="120" textAlign="Center"></e-column>
          <!--
          <e-column field="esn" :headerText="$t('Security.Lic.esn')" width="120" textAlign="Center"></e-column>
          <e-column field="displaySoftwareVersion" :headerText="$t('Topo.devSoftVersion')" width="120" textAlign="Center"></e-column>
           -->
          <e-column field="status" :headerText="$t('Security.Lic.uploadStatus')" width="120" textAlign="Center"  :formatter='uploadStatusFormat'></e-column>
          <e-column field="uploadTime" :headerText="$t('Security.Lic.uploadTime')" width="120" textAlign="Center"  :formatter='uploadDate'></e-column>
           <!--
          <e-column field="installTime" :headerText="$t('Security.Lic.installTime')" width="120" textAlign="Center"  :formatter='installDate'></e-column>
          -->
          <e-column field="activeTime" :headerText="$t('Security.Lic.activeTime')" width="120" textAlign="Center"  :formatter='actDate'></e-column>
        </e-columns>
      </ejs-grid>
      <iframe src='' style='display: none;' id='downloadAction'></iframe>
    </div>
    <CustomDialog ref="upDevLicDialog"
                  v-bind:element="upDevLicDialog.element"
                  v-bind:styles="upDevLicDialog.styles">
      <template slot="dialog-content">
        <ejs-uploader ref="upDevLic" name="upLicense" cssClass=".e-css.e-btn"
                    :asyncSettings="upDevSettings.asyncSettings"
                    :multiple="upDevSettings.multiple"
                    :autoUpload="upDevSettings.autoUpload"
                    :uploading="onFileUpload"
                    :allowedExtensions = "upDevSettings.extensions"
                    :success="uploadResult">
                    </ejs-uploader>
      </template>
    </CustomDialog>
    <CustomDialog ref="licDetailDialog"
                  v-bind:element="licDetailDialog.element"
                  v-bind:styles="licDetailDialog.styles">
      <template slot="dialog-content">
        <LicDetail ref="licDetail"></LicDetail>
      </template>
    </CustomDialog>
    <CustomDialog ref="licHistoryDialog"
                  v-bind:element="licHistoryDialog.element"
                  v-bind:styles="licHistoryDialog.styles">
      <template slot="dialog-content">
        <LicHistory ref="licHistory"></LicHistory>
      </template>
    </CustomDialog>
  </div>
</template>
<style>
    .e-css.e-btn {
      background-color:#007bff;
    }
    .e-css.e-btn:hover {
      background-color:#007bff;
    }
    .e-css.e-btn:focus {
      background-color:#007bff;
      border-color: #007bff;
      box-shadow: 0 0 0 0.25em rgba(0, 123, 255, 0.5);
    }
</style>
<script>
import CustomDialog from '../../common/CustomDialog';
import LicDetail from './licDetail';
import LicHistory from './licHistory';
import { EventBus } from "../../../plugins/eventBus";
import { resolve } from 'url';

export default {
    name: 'DeviceLicense',
    components: {
      CustomDialog,
      LicDetail,
      LicHistory
    },
    data() {
      return {
        devData: [],
        toolbarItems: [
          { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshList },
          { prefixIcon: 'icon hero-icon hero-icon-upload', tooltipText: this.$t('Common.upload'), click: this.showUpload },
          // { prefixIcon: 'icon hero-icon hero-icon-topo-mc_pf', tooltipText: this.$t('Security.install'), click: this.install },
          { prefixIcon: 'icon hero-icon hero-icon-confirm', tooltipText: this.$t('Security.active'), click: this.activeLicense },
          { prefixIcon: 'icon hero-icon hero-icon-disable', tooltipText: this.$t('Security.unActive'), click: this.unActiveLicense },
          // { prefixIcon: 'icon hero-icon hero-icon-synchronize',tooltipText: this.$t('Alarm.synchronize'), click: this.syncDevLicense},
          { prefixIcon: 'icon hero-icon hero-icon-details', tooltipText: this.$t('Common.detail'), click: this.showDetail },
          // { prefixIcon: 'icon hero-icon hero-icon-replenish-data', tooltipText: this.$t('Security.history'), click: this.showHistory },
          { prefixIcon: 'icon hero-icon hero-icon-download' , tooltipText: this.$t('Common.downloadFile') ,click: this.download }
        ],
        upDevLicDialog: {
          element: {
            target: '#app',
            isClose: true,
            refName: 'upDevLicDialog',
            buttonGroup: [
              {
                click: this.closeUpload,
                buttonModel: { content: `${this.$t('Common.close')}` }
              }
            ],
            title: `${this.$t('Login.uploadLicense')}`
          },
          styles: {
            width: '600px',
            height: '400px',
            model: true,
            visible: false
          }
        },
        licDetailDialog: {
          element: {
            target: '#app',
            isClose: true,
            refName: 'licDetailDialog',
            buttonGroup: [
              {
                click: this.closeDetail,
                buttonModel: { content: `${this.$t('Common.close')}` }
              }
            ],
            title: `${this.$t('Security.Lic.licenseDetail')}`
          },
          styles: {
            width: '800px',
            height: '500px',
            model: true,
            visible: false
          }
        },
        licHistoryDialog: {
          element: {
            target: '#app',
            isClose: true,
            refName: 'licHistoryDialog',
            buttonGroup: [
              {
                click: this.closeHistory,
                buttonModel: { content: `${this.$t('Common.close')}` }
              }
            ],
            title: `${this.$t('Security.Lic.licenseHistoryDetail')}`
          },
          styles: {
            width: '1200px',
            height: '500px',
            model: true,
            visible: false
          }
        },
        upDevSettings: {
          asyncSettings: {
            saveUrl: '/lte/ems/license/uploadDeviceLicense',
            removeUrl: ''
          },
          multiple: false,
          autoUpload: false,
          extensions: '.enc'
        },
      }
    },
  methods: {
    actStatusFormat(grids, data) {
      if(data.activeStatus == 1){
         return `${this.$t('Security.Lic.activeStatus_activated')}`;
      }else{
        return `${this.$t('Security.Lic.activeStatus_inactivated')}`;
      }
    },
    uploadStatusFormat(grids, data) {
      if(data.status == null){
        return `${this.$t('Security.Lic.uploadStatus_unupload')}`;
      }else if(data.status == 1){
         return `${this.$t('Security.Lic.uploadStatus_uploaded')}`;
      }else if(data.status == 2){
         return `${this.$t('Security.Lic.installStatus')}`;
      }else if(data.status == 3){
        return `${this.$t('Security.Lic.activeStatus_activated')}`;
      }
    },
    actDate(grids, data) {
      if(!!data.activeTime&&data.activeTime!=null){
        return this.formatDateTime(data.activeTime);
      }else{
        return '';
      }
    },
    uploadDate(grids, data) {
        if(!!data.uploadTime&&data.uploadTime!=null){
          return this.formatDateTime(data.uploadTime);
        }else{
          return '';
        }
    },
    installDate(grids, data) {
        if(!!data.installTime&&data.installTime!=null){
          return this.formatDateTime(data.installTime);
        }else{
          return '';
        }
    },
    formatDateTime(timeStamp) {
        var date = new Date();
        date.setTime(timeStamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
    },

    findDevList() {
      let url = '/lte/ems/license/findLicDevList';
      let That = this;
      this.axios.get(url, {}).then(response => {
        let result = response.data;
        That.devData = result;
      });
    },
    checkSelectRecord() {
      let record = this.$refs.grid.getSelectedRecords();
      if (record === null || record === '') {
        this.eventEmit('warning',`${this.$t('Common.tips.noSelect')}`);
        return false;
      }
      if (record.length === 0) {
        this.eventEmit('warning',`${this.$t('Common.tips.selectOne')}`);
        return false;
      }
      if (record.length !== 1) {
        this.eventEmit('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return false;
      }
      return true;
    },
    onFileUpload(args) {
      let record = this.$refs.grid.getSelectedRecords();
      args.customFormData = [{'id': record[0].id}]
    },
    showUpload() {
      if(this.checkSelectRecord()){
        this.$refs.upDevLicDialog.show();
      }
    },
    install(){
      if(this.checkSelectRecord()){
        let record = this.$refs.grid.getSelectedRecords();
        let url = '/lte/ems/license/install';
        let That = this;
         if(record[0].status==0 ) {
             this.eventEmit('warning',`${That.$t('Security.Lic.unUpload')}`);
         } else if(record[0].status!=1){
            this.eventEmit('warning',`${That.$t('Security.Lic.installed')}`);
         } else{
          this.$axios.post(url, 'id='+record[0].id).then(res => {
            console.log(res);
            if(!!res.data && res.data.success==0){
              That.eventEmit('success',res.data.msg);
              That.findDevList();
            }else{
              That.eventEmit('error',`${That.$t('Common.tips.failure')}`+':'+res.data.msg);
            }
          })
        }
      }
    },
    showDetail() {
       let That = this;
      if(this.checkSelectRecord()){
        let record = this.$refs.grid.getSelectedRecords();
        if( record[0].status>=1) {
            this.$refs.licDetail.findDevLicense(record[0].id, record[0].typeName);
            this.$refs.licDetailDialog.show();
          //  this.$axios.get("/lte/ems/license/qryNodeLinkStatus?id="+record[0].id).then(res => {
          //   console.log(res);
          //   if(!!res.data && res.data.success==0 ){
          //     if(res.data.status == 1){
          //       this.$refs.licDetail.findDevLicense(record[0].id);
          //       this.$refs.licDetailDialog.show();
          //     }else{
          //       this.eventEmit('warning',`${That.$t('MCS.neOffLine')}`);
          //     }
          //   }
          // })

        }else {
          this.eventEmit('warning',`${That.$t('Security.Lic.activeLicense_warntip1')}`);
        }
      }
    },
    showHistory(){
      let That = this;
      if(this.checkSelectRecord()){
        let record = this.$refs.grid.getSelectedRecords();
        this.$refs.licHistory.findDevLicenseHistory(record[0].id);
        this.$refs.licHistoryDialog.show();

      }
    },
    download(){
      let That = this;
      if (this.checkSelectRecord()) {
        let record = this.$refs.grid.getSelectedRecords();
        if( record[0].status>=1) {
          const dom = document.getElementById('downloadAction');
          dom.src = `/lte/ems/license/downloadLicense?id=${record[0].id}`;
        }else {
          this.eventEmit('warning',`${That.$t('Security.Lic.activeLicense_warntip1')}`);
        }
      }
    },
    closeDetail() {
      this.$refs.licDetailDialog.clear();
      this.$refs.licDetailDialog.close();
    },
    closeHistory() {
      this.$refs.licHistoryDialog.clear();
      this.$refs.licHistoryDialog.close();
    },
    activeLicense() {
      if(this.checkSelectRecord()){
        let record = this.$refs.grid.getSelectedRecords();
        let url = '/lte/ems/license/actDeviceLicense';
        let That = this;
        console.log(record)
         if(record[0].status == null || record[0].status ==0) {
             this.eventEmit('warning',`${That.$t('Security.Lic.activeLicense_warntip1')}`);
         } else if(record[0].status>=1){
          this.$axios.post(url, 'id='+record[0].id).then(res => {
            console.log(res);
            if(!!res.data && res.data.success==0){
              That.eventEmit('success',res.data.msg);
              That.findDevList();
            }else{
              That.eventEmit('error',`${That.$t('Common.tips.failure')}`+':'+res.data.msg);
            }
          })
        }
      }
    },
    unActiveLicense() {
      if(this.checkSelectRecord()){
        let record = this.$refs.grid.getSelectedRecords();
        let url = '/lte/ems/license/unActDeviceLicense';
        let That = this;
        console.log(record)
         if(record[0].status == null || record[0].status <3) {
             this.eventEmit('warning',`${That.$t('Security.Lic.unActiveLicense_warntip1')}`);
         } else if(record[0].status>=3){
          this.$axios.post(url, 'id='+record[0].id).then(res => {
            console.log(res);
            if(!!res.data && res.data.success==0){
              That.eventEmit('success',res.data.msg);
              That.findDevList();
            }else{
              That.eventEmit('error',`${That.$t('Common.tips.failure')}`+':'+res.data.msg);
            }
          })
        }
      }
    },
    syncDevLicense(){
      if(this.checkSelectRecord()){

        let record = this.$refs.grid.getSelectedRecords();

         if(record[0].activeStatus!=1 &&record[0].uploadStatus!=1) {
          let url = '/lte/ems/license/syncDeviceLicense';
          let That = this;
          this.$axios.post(url, 'id='+record[0].id).then(res => {

          if(!!res.data && res.data.success==0){
            That.eventEmit('success',res.data.msg);
            That.findDevList();
          }else{
            That.eventEmit('error',`${That.$t('Common.tips.failure')}`);
          }
        })
        }else {
          this.eventEmit('warning',`${That.$t('Security.Lic.syncDevLicense_warntip')}`);
        }

      }
    },
    closeUpload() {
      this.$refs.upDevLicDialog.clear();
      this.$refs.upDevLicDialog.close();
      this.findDevList();
    },
    uploadResult(args) {
      let event = args.e;
      let info = event.target.responseText;
      document.getElementsByClassName("e-file-status")[0].innerHTML = info;
      console.log(document.getElementsByClassName("e-file-status e-upload-success")[0].innerHTML);
    },
    refreshList() {
      this.findDevList();
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    }
  },
  mounted() {
      this.findDevList();
  }
}
</script>

